/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProcessState } from "./ProcessState";
import {
  ProcessStateFromJSON,
  ProcessStateFromJSONTyped,
  ProcessStateToJSON,
} from "./ProcessState";

export interface IngestionPartForIngestionCreateRequest {
  locked?: boolean;
  workflowId?: string | null;
  workflowContext?: object | null;
  state?: ProcessState;
  sequence: number;
  source?: string | null;
  context?: object | null;
  index?: Array<any> | null;
}

export function IngestionPartForIngestionCreateRequestFromJSON(
  json: any,
): IngestionPartForIngestionCreateRequest {
  return IngestionPartForIngestionCreateRequestFromJSONTyped(json);
}

export function IngestionPartForIngestionCreateRequestFromJSONTyped(
  json: any,
): IngestionPartForIngestionCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    locked: json["locked"],
    workflowId: json["workflow_id"],
    workflowContext: json["workflow_context"],
    state:
      json["state"] === undefined
        ? undefined
        : ProcessStateFromJSON(json["state"]),
    sequence: json["sequence"],
    source: json["source"],
    context: json["context"],
    index: json["index"],
  };
}

export function IngestionPartForIngestionCreateRequestToJSON(
  value: IngestionPartForIngestionCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    locked: value.locked,
    workflow_id: value.workflowId,
    workflow_context: value.workflowContext,
    state: ProcessStateToJSON(value.state),
    sequence: value.sequence,
    source: value.source,
    context: value.context,
    index: value.index,
  };
}
